module.exports = __webpack_public_path__ + "img/identity_2.8523ead4.jpg";